import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Field } from 'redux-form';


import { BaseField } from '../../fields';
import { required } from '../../forms/validators';
import { fileType } from '../../../propTypes';


const propTypes = exact({
  files: PropTypes.arrayOf(fileType).isRequired,
});


const TicketAttachmentUploadFormSection = (props) => {
  const { files } = props;
  return (
    <div>
      <Field
        name="files"
        component={() => { return null; }}
      />
      {files.map((file, index) => {
        return (
          <BaseField
            key={file.name}
            name={`file-${index}`}
            label={`Description for ${file.name}`}
            validate={required}
          />
        );
      })}
    </div>
  );
};


TicketAttachmentUploadFormSection.propTypes = propTypes;


export default TicketAttachmentUploadFormSection;
